module.exports = __webpack_public_path__ + "media/sub4-6-6.13155c05.mp4";